<script type="text/ecmascript-6">
    import Layout from '../layouts/Index.vue'
    import MainHeader from '../layouts/Header.vue'

    export default {
        name: 'PrivacyPolicy',

        components: {
            Layout,
            MainHeader,
        },

        metaInfo() {
            return {
                title: 'Privacy Policy',
            }
        },

        /**
         * The component's data.
         */
        data: () => ({
            body: '',
        }),


        /**
         * Created the component.
         */
        created() {
            this.fetchPrivacyPolicy();
        },

        methods: {
            /**
             *  Get the privacy policy.
             */
            async fetchPrivacyPolicy() {
                axios.get('/api/mmn/privacy-policy').then((response) => {
                    console.log(response.data);
                    this.body = response.data;
                }).catch((error) => {
                    console.log(error)
                });
            },
        }
    }
</script>

<template>
    <layout>

        <!---Main Content Start--->
        <div class="ms_content_wrapper ms_profile padder_top80">

            <main-header/>

            <div class="ms_radio_wrapper ms_purchase_wrapper">
                <div class="ms_heading">
                    <h1>Privacy Policy</h1>
                </div>
                <div class="row">
                    <div class="container" v-html="body"></div>
                </div>
            </div>
        </div>


    </layout>
</template>
